import apiFetch from '../apiFetch'

export default function (verracos_no_ubicacion, token) {
  return apiFetch({endPoint: `Combos/getVerracosSinUbicacion?verracos_no_ubicacion=` + verracos_no_ubicacion, method: 'GET', body: null, token: token})
}